/*
    创建者：shuxiaokai
    创建时间：2020-04-29 10:44
    模块名称：
    备注：xxxx
*/
<template>
    <div class="e">
        <s-markdown></s-markdown>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    created() {

    },
    methods: {
        //=====================================获取远程数据==================================//

        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//  
        
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">
.e {
    width: 800px;
    height: calc(100vh - #{size(160)});
}
</style>
